import React from 'react';
import { ExtensionComponentProps } from '@sharefiledev/sharefile-appshell';
import { Spin } from 'antd';
import { AiAgentConfigsExtensionParams } from '../../../types';

const LazyAiAgentConfigsViewListExtensionSlot = React.lazy(
	() => import('./AiAgentConfigsViewListExtensionSlot')
);

const AsyncAiAgentConfigsViewList: React.FC<
	ExtensionComponentProps<AiAgentConfigsExtensionParams>
> = props => {
	return (
		<React.Suspense fallback={<Spin />}>
			<LazyAiAgentConfigsViewListExtensionSlot {...props} />
		</React.Suspense>
	);
};

export default AsyncAiAgentConfigsViewList;
